// TunerManagement.js
import React, { useState, useEffect } from 'react';
import './TunerManagement.css';
import api from '../../utils/axios'; // Using axios instance

export const TunerManagement = () => {
    const [dailyMinuteLimit, setDailyMinuteLimit] = useState('');
    const [description, setDescription] = useState('');
    const [lastEditedDate, setLastEditedDate] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        setIsLoading(true);
        try {
            const response = await api.get('/system_settings/DAILY_MINUTE_LIMIT');
            const data = response.data;

            if (!data || !data.value) {
                throw new Error('Invalid response format');
            }

            setDailyMinuteLimit(data.value);
            setDescription(data.description || '');
            setLastEditedDate(data.lastEditedDate);
            setError('');
        } catch (error) {
            console.error('Fetch error:', error);
            setError(error?.response?.data?.message || 'Failed to fetch settings');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSave = async () => {
        if (!dailyMinuteLimit || isNaN(dailyMinuteLimit) || dailyMinuteLimit < 0) {
            setError('Please enter a valid number of minutes');
            return;
        }

        setIsLoading(true);
        try {
            const response = await api.put('/system_settings/DAILY_MINUTE_LIMIT', {
                value: dailyMinuteLimit,
            });

            const data = response.data;

            if (!data || !data.lastEditedDate) {
                throw new Error('Invalid response format');
            }

            setLastEditedDate(data.lastEditedDate);
            setError('');
        } catch (error) {
            console.error('Update error:', error);
            setError(error?.response?.data?.message || 'Failed to update settings');
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <div className="tuner-loading">Loading...</div>;
    }

    return (
        <div className="tuner-container">
            <h1 className="tuner-title">AI Tuner Management</h1>
            {error && <div className="tuner-error">{error}</div>}
            <div className="tuner-form">
                <div className="form-group">
                    <label>Description</label>
                    <p className="description-text">{description}</p>
                </div>
                <div className="form-group">
                    <label htmlFor="minuteLimit">Daily Minute Limit</label>
                    <input
                        id="minuteLimit"
                        type="number"
                        min="0"
                        value={dailyMinuteLimit}
                        onChange={(e) => setDailyMinuteLimit(e.target.value)}
                        className="input-field"
                    />
                </div>
                <div className="form-group">
                    <label>Last Edited</label>
                    <p className="date-text">
                        {lastEditedDate ? new Date(lastEditedDate).toLocaleString() : 'Never'}
                    </p>
                </div>
                <button
                    className="save-button"
                    onClick={handleSave}
                    disabled={isLoading}
                >
                    Save Changes
                </button>
            </div>
        </div>
    );
};